<template>
  <v-dialog :model-value="modelValue" @update:model-value="onUpdate" max-width="520" persistent>
    <v-card>
      <v-card-title class="text-h6">{{ $t('entry.unsaved_title') }}</v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="tonal" color="grey-darken-3" @click="onCancel">{{ $t('general.cancel') }}</v-btn>
        <v-spacer />
        <v-btn color="warning" variant="flat" @click="onConfirm">{{ $t('general.leave') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>







const props = defineProps({
  modelValue: { type: Boolean, default: false },  
  text: { type: String, required: true },          
})

const emit = defineEmits(['update:modelValue', 'cancel', 'confirm'])

function onUpdate(val) {
  emit('update:modelValue', val)
}
function onCancel() {
  emit('cancel')                 // ← rodič ví, že zrušil
  emit('update:modelValue', false)
}
function onConfirm() {
  emit('confirm')                // ← rodič ví, že potvrdil
  emit('update:modelValue', false)
}
</script>